export const formatDate = () => {
  const now = new Date();
  let hour: string | number = now.getHours();
  let minute: string | number = now.getMinutes();
  let second: string | number = now.getSeconds();
  if (hour < 10) hour = `0${hour}`;
  if (minute < 10) minute = `0${minute}`;
  if (second < 10) second = `0${second}`;
  return `${hour}:${minute}:${second}`;
};

function dateFormat(fmt: any, time: any) {
  let date = new Date(time);
  let ret;
  const opt = {
    // 年
    "Y+": date.getFullYear().toString(),
    // 月
    "m+": (date.getMonth() + 1).toString(),
    // 日
    "d+": date.getDate().toString()
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  } as any;
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}

// js获取昨日的日期 (修复：确保计算正确)
export const get1stAndToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();
  const yesterday = new Date(todayTime - 24 * 60 * 60 * 1000);
  
  let startDay1 = dateFormat("YYYY-mm-dd", yesterday.getTime());
  let endDay1 = dateFormat("YYYY-mm-dd", yesterday.getTime());
  return [startDay1, endDay1];
};

// 获取昨日、今日日期
export const getday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();
  const yesterday = new Date(todayTime - 24 * 60 * 60 * 1000);
  
  let yesterdayStr = dateFormat("YYYY.mm.dd", yesterday.getTime());
  let todayStr = dateFormat("YYYY.mm.dd", todayTime);
  return [yesterdayStr, todayStr];
};

// 获取近7日 (修复：计算前7天到昨天)
export const past7Day = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();
  
  const yesterday = new Date(todayTime - 24 * 60 * 60 * 1000);
  const past7days = new Date(todayTime - 7 * 24 * 60 * 60 * 1000);
  
  let days7Start = dateFormat("YYYY-mm-dd", past7days.getTime());
  let days7End = dateFormat("YYYY-mm-dd", yesterday.getTime());
  return [days7Start, days7End];
};

// 获取近30日 (修复：计算前30天到昨天)
export const past30Day = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayTime = today.getTime();
  
  const yesterday = new Date(todayTime - 24 * 60 * 60 * 1000);
  const past30days = new Date(todayTime - 30 * 24 * 60 * 60 * 1000);
  
  let days30Start = dateFormat("YYYY-mm-dd", past30days.getTime());
  let days30End = dateFormat("YYYY-mm-dd", yesterday.getTime());
  return [days30Start, days30End];
};

// 获取本周 (正确计算本周一到今天)
export const pastWeek = () => {
  const today = new Date();
  const dayOfWeek = today.getDay() || 7; // 将周日的0改为7
  
  // 本周一
  const monday = new Date(today);
  monday.setDate(today.getDate() - (dayOfWeek - 1));
  
  // 今天
  let weekStart = dateFormat("YYYY-mm-dd", monday.getTime());
  let weekEnd = dateFormat("YYYY-mm-dd", today.getTime());
  return [weekStart, weekEnd];
};

// 获取本月 (正确计算本月第一天到今天)
export const pastMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  
  // 本月第一天
  const firstDay = new Date(year, month, 1);
  
  // 今天
  let monthStart = dateFormat("YYYY-mm-dd", firstDay.getTime());
  let monthEnd = dateFormat("YYYY-mm-dd", today.getTime());
  return [monthStart, monthEnd];
};
